import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { clientUnitToServerMap } from 'app/businessRules';
import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { storeUnit as storeUnitActions } from '../actions';
import { STORE_UNIT } from '../constants/actionTypes';
import { saveUnit, updateUnit } from '../repository';


function *_storeUnit(action) {
    const {formData} = action;
    yield put(loadDataAction('storeUnit'));
    let payload = clientUnitToServerMap(formData);

    try {
        let unit;
        if (payload.trac) {
            unit = yield call(updateUnit(payload, payload.vtrac, payload.trac));
        } else {
            unit = yield call(saveUnit(payload, payload.vtrac));
        }
        yield put(storeUnitActions.success(unit, payload.vtrac));
        yield put(loadDataSuccessAction('storeUnit', 'unit.form.save.success'));
    } catch (error) {
        yield put(storeUnitActions.error(error));
        yield put(loadDataErrorAction('storeUnit', {response: error.response, body: error.body, titleId:'unit.form.save.failed'}, action));
    }

}


export function *storeUnit() {
    yield takeLatest(STORE_UNIT.REQUEST, _storeUnit);
}